import { ValidationRule } from './types';
import { isValidInput as validateInput } from '../../../utils';
import { BRAND_RELATIONSHIP_SCORE } from '@/constants';

export const isRequired = (value?: string | string[]) =>
  !!value?.length || 'Required';
export const isValidInput = (value?: string) =>
  validateInput(value?.trim() || '') || 'Invalid input';
export const isValidBrandRelationship = (value: number) =>
  BRAND_RELATIONSHIP_SCORE.some((item) => item.value === value) ||
  'Please select Brand Relationship';
export const isValidSenderId = (value?: string) =>
  /^[a-zA-Z0-9 ]{3,11}$/.test(value?.trim() ?? '') ||
  'Sender ID must be 3-11 characters (alphanumeric and spaces only)';
export const isValidSenderIds = (value?: string) => {
  if (!value) {
    return true;
  }

  const tags = value.split(',');
  if (tags.length > 5) {
    return 'Max 5 Sender IDs to block';
  }
  return tags.some((tag) => tag.length < 3 || tag.length > 11)
    ? 'Each tag must be 3-11 characters'
    : true;
};

export const createRequiredValidator =
  (message: string) => (value?: string | string[]) =>
    !!value?.length || message;
export const createMinLengthValidator =
  (minLength: number, optional = false) =>
  (value?: string) =>
    (optional && !value) ||
    (value?.length ?? 0) >= minLength ||
    `Minimum ${minLength} chars`;
export const createMaxLengthValidator =
  (maxLength: number, optional = false) =>
  (value?: string) =>
    (optional && !value) ||
    (value?.length ?? 0) <= maxLength ||
    `Maximum ${maxLength} chars are allowed`;
export const createPatternValidator =
  (pattern: RegExp, message: string) => (value?: string) =>
    !value || pattern.test(value ?? '') || message;
export const createEinValidator =
  (rule?: ValidationRule, name = 'EIN') =>
  (value?: string) => {
    const updatedValue =
      value?.trim().replace(/[ ^!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}\s]/gim, '') ??
      '';
    const pattern = rule?.regex
      ? new RegExp(rule.regex, 'gmi')
      : /^[0-9]{2}[-.s]?[0-9]{7}$/gim;
    return (
      pattern.test(updatedValue) ||
      `Invalid ${name} ${rule?.structure ? `- ${rule.structure}` : ''}`
    );
  };
export const createRequiredPhoneValidator =
  (countryCode: string, message: string) => (value?: string) =>
    (!!value?.length && value !== `+${countryCode}`) || message;
